export default __webpack_public_path__ + "static/media/sponsor-icon.eb3bcd14.webp";